/*公共方法*/
import VueCookies from 'vue-cookies'
import router from "../router/index";
import store from "../store";
import quoteVehicleInfo from "./QuoteVehicleInfo";
import channelConfig from "./ChannelConfig";
import Vue from 'vue'
import Ajax from './ajax'
import confirmTheInsured from "../components/insuranceInformation/confirmTheInsured";
// let u = navigator.userAgent;
// let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
// let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);   // ios终端
let TT = null
let util = {
  /**
   *  loading开始
   * */
  beginLoading() {
    if (document.getElementById('loading')) {
      document.getElementById('loading').style.display = 'block';
    }
  },
  /**
   *  loading结束
   * */
  finishLoading() {
    if (document.getElementById('loading')) {
      document.getElementById('loading').style.display = 'none';
    }
  },
  /**
   *  loading开始
   * */
  beginPolling() {
    if (document.getElementById('polling')) {
      document.getElementById('polling').style.display = 'block';
    }
  },
  /**
   *  loading结束
   * */
  finishPolling() {
    if (document.getElementById('polling')) {
      document.getElementById('polling').style.display = 'none';
    }
  },

  theme(theme) {
    // window.document.getElementById('theme').getAttribute('data-theme'))

    let skinCss = ""
    if (theme == null) {
      skinCss = "blue"
    } else skinCss = theme

    if (undefined == skinCss || "" == skinCss) skinCss = "blue"

    let themeColor = quoteVehicleInfo.theme[skinCss]
    let themeColorString = ""
    for (let keyIndex in themeColor) {
      themeColorString = themeColorString + "--" + keyIndex + ":" + themeColor[keyIndex] + ";"
    }
    theme = themeColor.theme
    themeColor = themeColorString

    store.commit("themeImgRootPath", skinCss)
    store.commit("themeMainColor", quoteVehicleInfo.theme[skinCss].mainColor);

    if (window.document.getElementById('theme') && window.document.getElementById('theme').getAttribute('data-theme') != skinCss) {
      window.document.getElementById('theme').setAttribute("data-theme", skinCss);
      window.document.getElementById('theme').setAttribute("style", themeColorString);
    }
    // if(window.document.getElementById('container'))
    // if(window.document.getElementById('container'))
  },

  // 获取保单全量信息/vehicle/loadQuoteInfo
  getLoadQuoteInfo(callBack) {
    let orderId = this.getQueryString('orderId')
    if (orderId) {
      Ajax.post('/vehicle/loadQuoteInfo', {orderId}).then(res => {
        if (!res) return
        let data = res.data.body || ''
        if (data.orderId) sessionStorage['orderId'] = data.orderId
        if (data.channelCode) sessionStorage['channelCode'] = data.channelCode

        // store.commit("quoteVehicleInfo",res.data.body)
        callBack(res.data.body)
      })
    }
  },
  async getLoadQuoteInfoAys() {
    let orderId = this.getQueryString('orderId')
    if (orderId) {
      let rs = await  Ajax.post('/vehicle/loadQuoteInfo', {orderId})
      let data = rs.data.body || ``
      if (data.orderId) sessionStorage['orderId'] = data.orderId
      if (data.channelCode) sessionStorage['channelCode'] = data.channelCode
      return data
    }
  },
  // 获取Token
  getToken() {
    Vue.prototype.$isLogin(true)
    // let channelCode = sessionStorage['channelCode'] || this.getQueryString('channelCode') || ''
    // let orderId = sessionStorage['orderId'] || this.getQueryString('orderId') || ''
    // let ext1 = this.getQueryString('ext1')
    // let ext1Str = ''
    // if(ext1) ext1Str = `&ext1=${ext1}`
    // let ext1Str1 = ''
    // if(channelCode) ext1Str1 = `&channelCode=${channelCode}`
    // let ext1Str2 = ''
    // if(orderId) ext1Str2 = `&orderId=${orderId}`
    //
    // let backUrl = this.delParam('token')
    // let baseApi
    // let locationHost = window.location.host
    // if(locationHost.includes('localhost') || locationHost.includes('80')){
    //   baseApi = process.env.BASE_API + '/api';
    //   // baseApi = 'http://192.168.1.75:8080/api';
    // }else{
    //   if(window.location.href.includes('https')){
    //     baseApi = "https://" + locationHost + '/api'
    //   }else{
    //     baseApi = "http://" + locationHost + '/api'
    //   }
    // }
    // sessionStorage.clear()
    // let loginSrc = `${baseApi}/login/mobileLogin?&backUrl=${backUrl}${ext1Str}${ext1Str1}${ext1Str2}`
    // window.location.href = loginSrc
  },
  // 获取信息 —— 登录
  loginIn(next, lastHref) {
    if (localStorage['token']) {
      let orderId = this.getQueryString('orderId')
      let channelCode = this.getQueryString('channelCode')
      let token = localStorage['token']
      let branchId = this.getQueryString('branchId') || localStorage['branchId']
      let parms = {token, orderId, channelCode, branchId}
      // if(branchId) parms['branchId'] = branchId
      Ajax.post('/login/userLogin', parms).then(res => {
        if (!res) return
        let permissionsArr = res.data.body.sysRoleLs
        let permissionsAll = []
        if (permissionsArr && permissionsArr.length) {
          permissionsArr.forEach(t => {
            t.uiLs.forEach(m => {
              permissionsAll.push(m.uiCode)
            })
          })
        }
        let permissions = [...new Set(permissionsAll)]
        store.commit("setGoHomeShow", permissions.includes('cs_working'))
        sessionStorage['permissions'] = JSON.stringify(permissions)
        Vue.prototype.permissions = permissions;

        let data = JSON.stringify(res.data.body) || ''
          localStorage['userData'] = data
        if (next) {
          lastHref = this.delParam('token', lastHref)
          if (window.location.href.includes('https')) {
            window.location.href = "https://" + window.location.host + '/hv2' + lastHref
          } else {
            window.location.href = "http://" + window.location.host + '/hv2' + lastHref
          }
        }
      })
    }
  },
  getChannelData(orderId, channelCode, next, lastHref) {
    Ajax.post('/vehicle/loadChannelConfig', {orderId, channelCode}).then(res => {
      if (!res) return
      let data = res.data.body;
      sessionStorage['channelCode'] = data.channelCode
      sessionStorage['channelConfig'] = JSON.stringify(data)
      if (orderId) sessionStorage['orderId'] = orderId
      this.theme(data.skinCss);
      if (next) {
        lastHref = this.delParam('token', lastHref)
        if (window.location.href.includes('https')) {
          window.location.href = "https://" + window.location.host + '/hv2' + lastHref
        } else {
          window.location.href = "http://" + window.location.host + '/hv2' + lastHref
        }
      }
    })
  },
  backChannelData(orderId, channelCode, back) {
    Ajax.post('/vehicle/loadChannelConfig', {orderId, channelCode}).then(res => {
      if (!res) return
      let data = res.data.body;
      sessionStorage['channelCode'] = data.channelCode
      sessionStorage['channelConfig'] = JSON.stringify(data)
      if (orderId) sessionStorage['orderId'] = orderId
      this.theme(data.skinCss);
      back(data)
    })
  },
  async backChannelDataAys(orderId, channelCode) {
    let params = {orderId,channelCode}
    if (orderId) {
      let rs = await  Ajax.post('/vehicle/loadChannelConfig', params)
      let data = rs.data.body || ``
      sessionStorage['channelCode'] = data.channelCode
      sessionStorage['channelConfig'] = JSON.stringify(data)
      if (orderId) sessionStorage['orderId'] = orderId
     // this.theme(data.skinCss);
      return data
    }
  },
  //获取配置信息
  getChannelConfig(lastHref, next) {
    // 登录
    let userData = localStorage['userData'] ? JSON.parse(localStorage['userData']) : ''
    if (!userData) {
      this.loginIn(next, lastHref)
    } else {
      let permissionsArr = userData.sysRoleLs
      let permissionsAll = []
      if (permissionsArr && permissionsArr.length) {
        permissionsArr.forEach(t => {
          t.uiLs.forEach(m => {
            permissionsAll.push(m.uiCode)
          })
        })
      }
      let permissions = [...new Set(permissionsAll)]
      sessionStorage['permissions'] = JSON.stringify(permissions)
      Vue.prototype.permissions = permissions;
      // 地址栏参数
      let orderId = this.getQueryString('orderId')
      let channelCode = this.getQueryString('channelCode')
      let channelCodeCookie = sessionStorage['channelCode']
      // cookie参数
      let orderIdCookie = sessionStorage['orderId']
      let channelConfig = sessionStorage['channelConfig']
      this.getChannelData(orderId, channelCode, next, lastHref)
      // if(channelCode){
      //   this.getChannelData(orderId,channelCode,next,to)
      // }else{
      //   if(channelConfig){
      //     if(orderId && orderId == orderIdCookie){
      //       this.theme(JSON.parse(channelConfig).skinCss);
      //       next()
      //     }else{
      //       this.getChannelData(orderId,'',next)
      //     }
      //   }else{
      //     this.getChannelData(orderId,'',next)
      //   }
      // }
    }
  },
  addStrinUrl(url, name, value) {
    //url字符串添加参数
    //url:路径地址 name：参数名 value：参数值
    if (url.indexOf(name) > -1) {
      var re = eval('/(' + name + '=)([^&]*)/gi');
      url = url.replace(re, name + '=' + value);
    } else {
      var paraStr = name + '=' + value;

      var idx = url.indexOf('?');
      if (idx < 0)
        url += '?';
      else if (idx >= 0 && idx != url.length - 1)
        url += '&';
      url = url + paraStr;
    }
    return url;
  },

  /**
   *  删除地址栏中，指定的参数名
   * */
  delParam(paramKey, urls) {
    let url = urls ? urls : window.location.href;    // 页面url
    let urlParam = url.split("?")[1];  // 页面参数
    let beforeUrl
    if (url.indexOf("?") !== -1) {
      beforeUrl = url.substr(0, url.indexOf("?"));  // 页面主地址（参数之前地址）
    } else {
      beforeUrl = url
    }
    let nextUrl = "";
    let arr = new Array();
    if (urlParam != "") {
      // 将参数按照&符分成数组
      let urlParamArr = urlParam.split("&");
      for (let i = 0; i < urlParamArr.length; i++) {
        let paramArr = urlParamArr[i].split("="); //将参数键，值拆开
        //如果键雨要删除的不一致，则加入到参数中
        if (paramArr[0] != paramKey) {
          arr.push(urlParamArr[i]);
        }
      }
    }
    if (arr.length > 0) {
      nextUrl = "?" + arr.join("&");
    }
    url = beforeUrl + nextUrl;
    return url;
  },
  /**
   * 日期格式化
   * eg:{{data | wq_capitalize('yyyy-MM-dd hh:mm')}}
   *  **/
  filterDateStr(value, f) {
    if (!value) return '';
    if (!f) f = 'yyyy-MM-dd hh:mm:ss';
    // if(isiOS) f= f.replace(/-/g, '/')
    let elem = new Date(value.replace(/-/g, '/'));
    let o = {
      "M+": elem.getMonth() + 1, //月
      "d+": elem.getDate(),    //d日
      "h+": elem.getHours(),   //时
      "m+": elem.getMinutes(), //分
      "s+": elem.getSeconds(), //秒
      "q+": Math.floor((elem.getMonth() + 3) / 3),
      "S": elem.getMilliseconds()
    }
    if (/(y+)/.test(f)) f = f.replace(RegExp.$1, (elem.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o) if (new RegExp(
      "(" + k + ")").test(f)) f = f.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    return f
  },
  //明天的时间
  tomorrowStr(data) {
    let day3 = data || new Date();
    day3.setTime(day3.getTime() + 24 * 60 * 60 * 1000);
    return day3.getFullYear() + "-" + (day3.getMonth() + 1) + "-" + day3.getDate();
  },
  /**
   * 日期格式化
   * eg:{{data | wq_capitalize('yyyy-MM-dd hh:mm')}}
   *  **/
  filterDateStr00(value, f, is23) {
    if (!value) return '';
    if (!f) f = 'yyyy-MM-dd hh:mm:ss';
    if (!value.toString().includes('/') && !value.toString().includes('-') && value.toString().length == 8) {
      value = value.substring(0, 4) + '-' + value.substring(4, 6) + '-' + value.substring(6, 8)
    }
    // if(isiOS) f= f.replace('-', '/')
    let elem = new Date(value);
    let o = {
      "M+": elem.getMonth() + 1, //月
      "d+": elem.getDate(),    //d日
      "h+": is23 ? "23" : "00",   //时
      "m+": is23 ? "59" : "00", //分
      "s+": is23 ? "59" : "00", //秒
      "q+": Math.floor((elem.getMonth() + 3) / 3),
      "S": elem.getMilliseconds()
    }
    if (/(y+)/.test(f)) f = f.replace(RegExp.$1, (elem.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o) if (new RegExp("(" + k + ")").test(f)) f = f.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    return f
  },
  // 清除字符串空格
  strTrim(str = '') {
    str = str ? str: ''
    var result;
    result = str.replace(/(^\s+)|(\s+$)/g,"");
    result = result.replace(/\s/g,"");
    return result;
  },
  dateMinMax(value, type) {
    if (!value) return '';
    let f = 'yyyy-MM-dd';
    if (!value.toString().includes('/') && !value.toString().includes('-') && value.toString().length == 8) {
      value = value.substring(0, 4) + '-' + value.substring(4, 6) + '-' + value.substring(6, 8)
    }
    let elem = new Date(value);
    let o = {
      "M+": elem.getMonth() + 1, //月
      "d+": type == 'max' ? elem.getDate() : elem.getDate() - 1,    //d日
    }
    if (/(y+)/.test(f)) f = f.replace(RegExp.$1, (elem.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o) if (new RegExp("(" + k + ")").test(f)) f = f.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    return f
  },
  yearAddOne(dateText, is23) {
    // TODO 时分秒为23:59:59
    if (!dateText) return '';
    let date = new Date(dateText.replace(/-/g, '/'));
    date.setFullYear(date.getFullYear() + 1);
    date.setDate(date.getDate() - 1);
    return this.filterDateStr00(date, '', is23)
  },
  // 获取地址栏参数
  getQueryString: function (name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    if (window.location.href.split("?")[1] != undefined) {
      let r = window.location.href.split("?")[1].match(reg);
      if (r == undefined && window.location.href.split("?").length > 2) {
        r = window.location.href.split("?")[2].match(reg);
      }
      if (r != null) return decodeURIComponent(r[2]);
      return null;
    }
  },

  //文件流下载到本地
  Export(data, fileName) {
    const blob = new Blob([data]);
    if ('download' in document.createElement('a')) { // 非IE下载
      const elink = document.createElement('a');
      elink.setAttribute("download", fileName);
      elink.style.display = 'none';
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href);// 释放URL 对象
      document.body.removeChild(elink);
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName);
    }
  },
  // 限制输入框为数字，且限制位数
  isnumber(val, num) {
    val = val.replace(/[^0-9]/gi, "");
    if (num) {
      if (val.length > num) val = val.slice(0, num);
      if (val < 0) val = 0
    }
    return val;
  },
  // 限制输入框为数字，且限制位数
  isPointNumber(val, num) {
    val = val.replace(/^\\d+(\\.\\d+)?$/gi, "");
    if (num) {
      if (val.length > num) val = val.slice(0, num);
      if (val < 0) val = 0
    }
    return val;
  },
  // 正则验证验证
  validateReg(type, str) {
    const phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    const IDCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    const number6Reg = /^\d{n}$/;//n位的数字：
    const passwordReg = /^[a-zA-Z]\w{5,17}$/;
    if (type == 'phone') {
      return phoneReg.test(str) ? '' : '手机号不正确'
    } else if (type == 'IDCard') {
      return IDCardReg.test(str) ? '' : '身份证号不正确'
    } else if (type == 'number6') {
      return number6Reg.test(str) ? '' : '请输入6位数字'
    } else if (type == 'password') {
      return passwordReg.test(str) ? '' : '请输入6~18位数字、字母组合密码'
    }
  },

  toError(id) {
    router.push({path: '/error', query: {errorId: id}})
  },
  //存入缓存
  setsessionStorage(name, item) {
    let time = '30d'
    VueCookies.set(name, item, time, '/')
  },
  //调用缓存
  getLocalstorage(name) {
    // 用vue-cookie
    return VueCookies.get(name)
  },
  //  用vue-cookie删除 cookie
  removeLocalstorage(name) {
    VueCookies.remove(name)
  },
  // 清除所有cookie
  clearCookie() {
    let cookieAll = VueCookies.keys()
    if (cookieAll.length) {
      cookieAll.forEach(t => {
        VueCookies.remove(t)
      })
    }
  },
  // 过滤空对象
  filterObj(obj) {
    let newObj = {}
    for (let i in obj) {
      let o = {};
      if (obj[i] !== null && obj[i] !== '') {
        newObj[i] = obj[i]
      }
    }
    return newObj
  },
  //  TODO 公共方法


  /**
   * 验证邮箱规则
   * @param c
   * @returns {boolean}
   */
  chkEMail: function (c) {
    let emailRule = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
    if (emailRule.test(c)) {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 验证手机号规则
   * @param c
   * @returns {boolean}
   */
  chkMobilePhone: function (c) {
    let b = /^(1)(3|4|5|6|7|8|9)\d{9}$/;
    if (b.test(c)) {
      return true
    } else {
      return false
    }
  },
  /**
   * 验证座机号规则
   * @param c
   * @returns {boolean}
   */
  chkTelPhone: function (c) {
    let phone = /^0\d{2,3}-[1-9]\d{6,7}$/;
    return phone.test(c);
  },
  /**
   * 验证座机号规则
   * @param c
   * @returns {boolean}
   */
  chkDate: function (c) {
    let dateRgx = /^(\d{4})(-)(\d{2})(-)(\d{2})$/;
    return dateRgx.test(c);
  },
  /**
   * 校验统一社会信用编码
   * @param Code
   * @returns {boolean}
   */
  checkSocialCreditCode: function (Code) {
    let patrn = /^[0-9A-Z]+$/;
    //18位校验及大写校验
    if ((Code.length != 18) || (patrn.test(Code) == false)) {
      return false;
    } else {
      let Ancode;//统一社会信用代码的每一个值
      let Ancodevalue;//统一社会信用代码每一个值的权重
      let total = 0;
      let weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];//加权因子
      let str = '0123456789ABCDEFGHJKLMNPQRTUWXY';
      //不用I、O、S、V、Z
      for (let i = 0; i < Code.length - 1; i++) {
        Ancode = Code.substring(i, i + 1);
        Ancodevalue = str.indexOf(Ancode);
        total = total + Ancodevalue * weightedfactors[i];
        //权重与加权因子相乘之和
      }
      let logiccheckcode = 31 - total % 31;
      if (logiccheckcode == 31) {
        logiccheckcode = 0;
      }
      let Str = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y";
      let Array_Str = Str.split(',');
      logiccheckcode = Array_Str[logiccheckcode];

      let checkcode = Code.substring(17, 18);
      if (logiccheckcode != checkcode) {
        return false;
      }
      return true;
    }
  },
  /**
   * 证件号验证规则
   * @param c
   * @returns {boolean}
   */
  chkIdentity: function (c) {
    let d = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江 ",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北 ",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏 ",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外 "
    };
    let l = true;
    if (!c || !/^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(c)) {
      l = false
    } else {
      if (!d[c.substr(0, 2)]) {
        l = false
      } else {
        if (c.length == 18) {
          c = c.split("");
          let h = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          let e = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
          let g = 0;
          let j = 0;
          let b = 0;
          for (let f = 0; f < 17; f++) {
            j = c[f];
            b = h[f];
            g += j * b
          }
          let k = e[g % 11];
          if (e[g % 11] != c[17]) {
            l = false
          }
        }
      }
    }
    return l
  },
  /**
   * 对象赋值
   * @param srcObj
   * @param descObj
   */
  copy(srcObj) {
    return JSON.parse(JSON.stringify(srcObj));
  },

  /**
   * 判断是否为空
   * @param value
   * @returns {boolean}
   */
  isNull(value) {
    if (value == undefined || value.length < 1) {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 获取当前请求连接
   * @returns {string}
   */
  getCurrentURL() {
    return window.location.href;
  },

  /**
   * 是否微信浏览器打开
   * @returns {boolean}
   */
  isWechatBrowser() {
    if (iSports.utils.isMobile() == true) {
      let userAgent = _iSports.browser.userAgent();
      if (userAgent.match(/MicroMessenger/i) == "MicroMessenger") {
        return true;
      }
    }
    return false;
  },
  /**
   * 是否移动端浏览器访问
   * @returns {boolean}
   */
  isMobile() {
    let userAgent = _iSports.browser.userAgent();
    if (userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
      return true;
    }
    return false;
  },

  /**
   * 任意字符转日期格式文本
   * @param strDate
   * @returns {string|null}
   */
  toDateString(strDate) {
    if (strDate == null) {
      return null;
    }

    let date = strDate.replace(/[^0-9.]/g, "");
    date = strDate.substr(0, 4) + "-" + date.substr(4, 2) + "-" + date.substr(6, 2);

    let newDate = new Date(date);
    if (newDate.toString() == 'Invalid Date') {
      return null;
    } else {
      return date;
    }
  },
  checkDate(str) {
    str = str.replace(/[^0-9.]/g, "");
    let year = str.substr(0, 4)
    let month = str.substr(4, 2)
    let data = str.substr(6, 2)
    let d = new Date(year, month - 1, data);
    return (d.getFullYear() == year && (d.getMonth() + 1) == month && d.getDate() == data);
  },
  premiumStr(premium, coverCode, seats, fixDays) {
    if (coverCode == 'C_05') {
      return `${seats}座x${premium / 10000}万`
    } else if (coverCode == 'C_10') {
      return `${fixDays}天x${premium}元/天`
    } else if (coverCode == 'C_20' || coverCode == 'C_21' || coverCode == 'C_22' || coverCode == 'C_23') {
      return `${premium}次`
    } else if (coverCode == 'C_25' || coverCode == 'C_29' || coverCode == 'C_32' || coverCode == 'C_35') {
      return `${premium}%`
    } else if (coverCode == 'C_30' || coverCode == 'C_33' || coverCode == 'C_36') {
      return premium == 0 ? '共享保额' : premium
    } else if (coverCode == 'C_01' || coverCode == 'C_03') {
      return premium
    } else {
      if (premium < 10000) {
        return premium == '0.0' ? '' : premium
      } else {
        return `${premium / 10000}万`
      }
    }
  },
  os() {
    var ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid &&       !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian;
    return {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isPc: isPc
    };
  },
  goOfferPAJudge(data) {
    let Judge = [
      'vehicleFrameNo', // “车架号”
      'engineNo', // “发动机号”
      'ownerName', // “车主姓名”
      'ownerIdentityNo', // “车主证件号”
      'phName', // “投保人姓名”
      'phIdentityNo', // “投保人证件号”
      'insuredName', // “被保人姓名”
      'insuredIdentityNo', // “被保人证件号”
    ]
    for (let i = 0; i < Judge.length; i++) {
      if (data[Judge[i]].indexOf('*') !== -1){
        return true
      }
    }
    return false
  },
  getTime(timestamp) {
    var date = new Date(timestamp);
    let Y = date.getFullYear(),
      M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1),
      D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()),
      h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()),
      m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()),
      s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
    return `${Y}-${M}-${D}`
  },
  /**
   * @description: 控制input框只能输入数字  小数点后两位
   */
   clearNum(value){
    let filterValue = value.toString();
    filterValue = filterValue.replace(/^\./g, "");  //  不能以“.”开头
    filterValue = filterValue.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
    filterValue = filterValue.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
    filterValue = filterValue.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    filterValue = filterValue.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3');//只能输入两个小数
    if (filterValue.indexOf(".") < 0 && filterValue != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
      filterValue = parseFloat(filterValue);
    }
    return filterValue;
  },

  checkSameValues(arr1, arr2) {
  // 遍历数组1，检查其中的 name 值是否存在于数组2中的 job 值中
    for (const item of arr1) {
      if (arr2.some((item2) => item2.ysField === item.coverCode)) {
        return true; // 如果找到相同的值，返回 true
      }
    }
    return false; // 如果遍历完数组1仍未找到相同的值，返回 false
  },
  // func: 执行函数, wait: 等待时间, immediate: 是否立即执行
  debounce(func,wait,immediate) {
    let timeout;
    return function () {
      let context = this;
      let args = arguments;
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(() => {
          timeout = null;
          func.apply(context, args)
        }, wait)
        if (callNow) func.apply(context, args)
      }
      else {
        timeout = setTimeout(function(){
          func.apply(context, args)
        }, wait);
      }
    }
  }
}
export default util;



// WEBPACK FOOTER //
// ./src/public/common.js